import React from 'react';
import { useHistory } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShip, faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons';

const DeliveryLinkBadge = ({ deliveryId, deliveryNumber }) => {
  const history = useHistory();

  if (!deliveryId) return null;

  const displayNumber = deliveryNumber || `#${deliveryId}`;

  return (
    <button
      className="delivery-link-badge"
      onClick={(e) => {
        e.stopPropagation();
        history.push(`/deliveries/${deliveryId}`);
      }}
      title={`Open linked delivery ${displayNumber}`}
    >
      <FontAwesomeIcon icon={faShip} className="delivery-link-badge-icon" />
      <span className="delivery-link-badge-text">{displayNumber}</span>
      <FontAwesomeIcon icon={faExternalLinkAlt} className="delivery-link-badge-arrow" />
    </button>
  );
};

export default DeliveryLinkBadge;
